// @flow

/**
 * Standard Font Metrics (AFM) for pdfmake/pdfkit
 *
 * When using the PDF "standard 14" fonts (Helvetica/Courier/Times/etc) in the
 * browser build, pdfkit expects the corresponding AFM metric files to be
 * available via pdfmake's virtual file system under keys like:
 *   - data/Helvetica-Bold.afm
 *
 * pdfkit ships these AFM files in its npm package (pdfkit/js/data/*.afm).
 * We bundle them as plain text and base64-encode them into pdfMake.vfs.
 */

import helvetica from 'bundle-text:pdfkit/js/data/Helvetica.afm';
import helveticaBold from 'bundle-text:pdfkit/js/data/Helvetica-Bold.afm';
import helveticaOblique from 'bundle-text:pdfkit/js/data/Helvetica-Oblique.afm';
import helveticaBoldOblique from 'bundle-text:pdfkit/js/data/Helvetica-BoldOblique.afm';

import courier from 'bundle-text:pdfkit/js/data/Courier.afm';
import courierBold from 'bundle-text:pdfkit/js/data/Courier-Bold.afm';
import courierOblique from 'bundle-text:pdfkit/js/data/Courier-Oblique.afm';
import courierBoldOblique from 'bundle-text:pdfkit/js/data/Courier-BoldOblique.afm';

const standardFontMetricsVfs = {
  // Keys must match pdfkit lookups (see error: data/Helvetica-Bold.afm)
  'data/Helvetica.afm': { data: helvetica, encoding: 'utf8' },
  'data/Helvetica-Bold.afm': { data: helveticaBold, encoding: 'utf8' },
  'data/Helvetica-Oblique.afm': { data: helveticaOblique, encoding: 'utf8' },
  'data/Helvetica-BoldOblique.afm': { data: helveticaBoldOblique, encoding: 'utf8' },

  'data/Courier.afm': { data: courier, encoding: 'utf8' },
  'data/Courier-Bold.afm': { data: courierBold, encoding: 'utf8' },
  'data/Courier-Oblique.afm': { data: courierOblique, encoding: 'utf8' },
  'data/Courier-BoldOblique.afm': { data: courierBoldOblique, encoding: 'utf8' },
};

export const applyStandardFontMetricsToVfs = (pdfMake: any): void => {
  if (!pdfMake) return;

  // pdfmake's browser build exposes addVirtualFileSystem(vfs)
  if (typeof pdfMake.addVirtualFileSystem === 'function') {
    pdfMake.addVirtualFileSystem(standardFontMetricsVfs);
    return;
  }

  // Fallback (defensive): write directly to underlying virtualfs if present
  if (pdfMake.virtualfs && typeof pdfMake.virtualfs.writeFileSync === 'function') {
    Object.keys(standardFontMetricsVfs).forEach((key) => {
      const entry = standardFontMetricsVfs[key];
      pdfMake.virtualfs.writeFileSync(key, entry.data, entry.encoding);
    });
  }
};
